module.exports = __webpack_public_path__ + "static/media/road.287f9ff3.kml";